import React, { useState, useEffect, useContext } from "react";
import { safeStr, getBqnIdCmdPart } from "common/api";
import { PERIOD_TO_HOURS } from "common/constants";
import Request from "common/Request";
import { parseServiceLatencies } from "../DPI/Latency/api";
import DPILatencies from "../DPI/Latency/Result/index";
import BqnContext from "common/BqnContext";
import ActionsContext from "common/ActionsContext";

const latencyRetrieval = ({ hours, categories, subscriberGroup, mode, bqnId }) => {
  return ifCl
    .run(
      `show statistics dpi latency top hours ${hours} categories ${
        categories - 1
      } all-subs all-internet subscriber-groups name ${safeStr(
        subscriberGroup
      )}${getBqnIdCmdPart(mode, bqnId)}`
    )
    .then(parseServiceLatencies)
    .then((latencies) => {
      return {
        latencies,
      }
    });
};

const SubscriberGroupLatency = ({
  range,
  categories,
  direction,
  period,
  subscriberGroup,
}) => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  const hours = PERIOD_TO_HOURS[period] || 24;
  const context = { interval:10, hours, directions:direction, categories, subscriberGroup };

  const doLoad = () => {
    setRequest(latencyRetrieval({ hours, categories, subscriberGroup, mode, bqnId }));
  };

  useEffect( () => actions.recv('do-load-details', doLoad), []);

  useEffect(
    () => doLoad(),
    [hours, categories, direction, period, subscriberGroup, bqnId]
  );
  return (
    <div>
      <Request during={request}>
        {({latencies}) => {
          return <DPILatencies latencies={latencies} range={range} {...context} className="subscriber-dashboard"/>;
        }}
      </Request>
    </div>
  );
};

export default SubscriberGroupLatency;
